var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1698_3537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.76074 8.49609H11.6486",
    stroke: "#B93815",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75781 2.82422V9.87895H0.351562V2.82422C0.351562 2.4375 0.667969 2.12109 1.05469 2.12109C1.44141 2.12109 1.75781 2.43752 1.75781 2.82422Z",
    stroke: "#B93815",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6484 8.47266V9.87891H10.2422V8.56369",
    stroke: "#B93815",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29688 7.08984H1.80469",
    stroke: "#B93815",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70361 5.68359H5.38912",
    stroke: "#B93815",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29688 5.68359H10.9922C11.3531 5.68359 11.6484 5.97891 11.6484 6.33984V8.49607H5.29688V5.68359Z",
    stroke: "#B93815",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70312 5.8999V8.28019",
    stroke: "#B93815",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76074 3.64453H1.8187C2.90557 3.64453 3.79202 4.53098 3.79202 5.61785V5.68413H1.76074V3.64453Z",
    stroke: "#B93815",
    strokeWidth: 0.8,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1698_3537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.338533cf3ce9788133f1e2b06198d2a8.svg";
export { ForwardRef as ReactComponent };